


import { Collapse, Table, Tag } from 'antd';
import React, { useState } from 'react';



function ProblemTableComponent() {

  const top_problems_columns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'top_problems_id',
      width: '2.5%',
    },
    {
      title: 'Статус решения',
      dataIndex: 'status',
      key: 'top_problems_status',
      textWrap: 'word-break',
      ellipsis: true,
      render: (status, record) => {
          if (status === 'Не решен') {
            return (
              <Tag color="red" key={record.id}>
              {status}
            </Tag>
            )
          } else if (status == 'На рассмотрении') {
            return (
              <Tag color="gold" key={record.id}>
                {status}
              </Tag>
            )
          } else if (status == 'Решен') {
            return (
              <Tag color="green" key={record.id}>
                {status}
              </Tag>
            )
          }


      },
    },
    {
      title: 'Наименование проблемы',
      dataIndex: 'name',
      key: 'top_problems_name',
    },
    {
      title: 'Приоритет',
      dataIndex: 'level',
      key: 'top_problems_level',

    },
    {
      title: 'Плановый срок решения',
      dataIndex: 'plan_date',
      key: 'top_problems_plan_date',
    },
    {
      title: 'Ответственный орган',
      dataIndex: 'responsible',
      key: 'top_problems_responsible',
    }

  ];

  const top_problems_current_data_final = [
    {
      id: 1,
      name: 'Коллизия в НПА по процедуре обнуления ставок НДПИ для низкорентабильных месторождений',
      level: 'Высокий',
      status: 'Решен',
      registration_date: '22/08/2025',
      plan_date: '01/11/2025',
      fact_date: '',
      responsible: 'МНЭ, МПС',
      solution:
        'Корреспондировать нормы КоН, ППРК от 21 мая 2018 года № 282 с принятыми поправками в Налогового кодексе по обнулению ставок НДПИ для низкорентабильных месторождений. Внести в КоН определение по началу промышленной добычи ',
      gov_position: '',
      protocol: '',
      protocol_deadlines: '',
      protocol_overdue: '',
      effect: [
        '1. Количество компаний - 2 621',
        '2. Налогооблагаемая база:',
        '2024 год - 2 979,8 млрд. тенге',
        '2025 год - 1 456,1 млрд. тенге',
        '3. Количество занятых:',
        '2024 год - 51 824 чел.',
        '2025 год - 79 616 чел.',
      ],
    },
    {
      id: 2,
      name: 'Введение ЭТП на ферросплавы, алюминий необработанный и др.',
      level: 'Высокий',
      status: 'Решен',
      registration_date: '22/08/2025',
      plan_date: '01/07/2026',
      fact_date: '',
      responsible: 'МинФин, МПС, МТИ',
      solution: 'Отменить практику введения экспортной таможенной пошлины ',
      gov_position:
        'Министерством финансов предлагается введение ЭТП в качестве фискальной меры для пополнения бюджета ',
      protocol: '',
      protocol_deadlines: '',
      protocol_overdue: '',
    },


  ];


  const top_problems_current_data = [


    {
      id: 1,
      name: 'Централизация в бюджет отчислений недропользователей на финансирование НИОКР',
      level: 'Высокий',
      status: 'Не решен',
      registration_date: '22/08/2025',
      plan_date: '01/09/2025',
      fact_date: '',
      responsible: 'МНВО, МПС, МЭ',
      solution:
        'Сохранить возможность фининансирования прикладной науки в ГМК за счет средств недропользователей',
      gov_position:
        'МНВО предлагается пересмотреть порядок финансирования НИОКР, направив все средства недропользователей в бюджет',
      protocol: '',
      protocol_deadlines: '',
      protocol_overdue: '',
    },
    {
      id: 2,
      name: 'Высокая стоимость электроэнергии для производства ферросплавной продукции',
      level: 'Высокий',
      status: 'Не решен',
      registration_date: '22/08/2025',
      plan_date: '01/01/2026',
      fact_date: '',
      responsible: 'МЭ, МНЭ',
      solution:
        'Установить предельный тариф на электроэнергию для ферроспланых предприятий на уровне 16 тенге за кВт/ч. Зафиксировать данный тариф до 2027 года, обеспечив прозрачность, стабильность и предсказуемость ценообразования.',
      gov_position: '',
      protocol: '',
      protocol_deadlines: '',
      protocol_overdue: '',
    },
    {
      id: 3,
      name: 'Отсутствие поправок по Соглашениям о переработке ТПИ',
      level: 'Высокий',
      status: 'Не решен',
      registration_date: null,
      plan_date: '01/01/2026',
      fact_date: '',
      responsible: 'МПС',
      solution: '',
      gov_position: '',
      protocol: '',
      protocol_deadlines: '',
      protocol_overdue: '',
    },
    {
      id: 4,
      name: 'Разработка Дорожной карты развития ГМК',
      level: 'Средний',
      status: 'На рассмотрении',
      registration_date: null,
      plan_date: '15/10/2025',
      fact_date: '',
      responsible: 'МПС',
      solution: '',
      gov_position: '',
      protocol: '',
      protocol_deadlines: '',
      protocol_overdue: '',
    },
    {
      id: 5,
      name: 'Совершенствование порядка возврата НДС',
      level: 'Средний',
      status: 'На рассмотрении',
      registration_date: '22/08/2025',
      plan_date: '01/11/2025',
      fact_date: '',
      responsible: 'МНЭ',
      solution:
        'в разрабатываемых Правилах возврата НДС, вступающих в силу с 1 января 2026 г., установить  порядок возврата дебетового НДС, по которому экспортеры несут ответственность исключительно по сделкам, совершенным с непосредственными поставщиками ',
      gov_position: '',
      protocol: '',
      protocol_deadlines: '',
      protocol_overdue: '',
    },
  ];


  const top_problems_systemic_data = [
    {
      id: 1,
      name: 'Отсутствие долгосрочной программы развития ГМК',
      level: 'Высокий',
      status: 'Не решен',
      registration_date: '22/08/2025',
      plan_date: '31/12/2025',
      fact_date: '',
      responsible: 'МПС',
      solution: 'Разработка долгосрочной программы развития ГМК ',
      gov_position: '',
      protocol:
        'подпункт 1) пункта 2 раздела 2. О развитии горно-металлургического комплекса Протокола СОП  от 18 октября 2024 года № 12-03/07-1401',
      protocol_deadlines: '',
      protocol_overdue: '',
      effect: [
        '1. Количество компаний - 2 621',
        '2. Налогооблагаемая база:',
        '2024 год - 2 979,8 млрд. тенге',
        '2025 год - 1 456,1 млрд. тенге',
        '3. Количество занятых:',
        '2024 год - 51 824 чел.',
        '2025 год - 79 616 чел.',
      ],
    },
    {
      id: 2,
      name: 'Обязательства по внедрению НДТ для объектов I категории ',
      level: 'Высокий',
      status: 'Не решен',
      registration_date: '22/08/2025',
      plan_date: '01/10/2025',
      fact_date: '',
      responsible: 'МЭПР',
      solution: 'Введение отлагательной нормы по внедрению НДТ',
      gov_position: '',
      protocol: '',
      protocol_deadlines: '',
      protocol_overdue: '',
    },
    {
      id: 3,
      name: 'Отмена дифференциации тарифов на услуги МЖС, планы по повышению тарифов на жд перевозки',
      level: 'Высокий',
      status: 'Не решен',
      registration_date: '22/08/2025',
      plan_date: '14/09/2025',
      fact_date: '',
      responsible: 'МНЭ, МинТранс',
      solution:
        'Недопущение отмены дифференциации тарифов по родам грузов, пересмотр планируемого роста тарифов на грузовые жд перевозки ',
      gov_position:
        'КТЖ планируется дальнейший рост тарифов на услуги грузовых перевозок жд транспортом',
      protocol: '',
      protocol_deadlines: '',
      protocol_overdue: '',
    },

    {
      id: 4,
      name: 'Доступ средних предприятий в ГМК к системе госфинансирования',
      level: 'Высокий',
      status: 'Не решен',
      registration_date: '22/08/2025',
      plan_date: '14/09/2025',
      fact_date: '',
      responsible: 'МНЭ РК',
      solution:
        'Исключить из пункта 8 Правил осуществления деятельности АО «Фонд развития промышленности» запрет на финансирование геологоразведочных работ',
      gov_position: '',
      protocol:
        'раздела 2. О развитии горно-металлургического комплекса Протокола СОП  от 18 октября 2024 года № 12-03/07-1401',
      protocol_deadlines: '',
      protocol_overdue: '',
    },
    {
      id: 5,
      name: 'Проблемы получения дополнительных земельных участков для недропользования',
      level: 'Средний',
      status: 'На рассмотрении',
      registration_date: '22/08/2025',
      plan_date: '30/12/2025',
      fact_date: '',
      responsible: 'МПС, МСХ',
      solution:
        'Предусмотреть в Земельном кодексе одним из оснований прекращения права частной собственности на земельный участок или права землепользования отчуждение земельного участка  при обнаружении месторождения',
      gov_position: '',
      protocol: '',
      protocol_deadlines: '',
      protocol_overdue: '',
    },
  ];








  return (
    <div>
      <h2 style={{margin: 0, marginBottom: '20px'}}>Проблемные вопросы </h2>
      <Collapse
        defaultActiveKey={['1']}

        items={[
          {
            key: '1',
            label: 'Текущие',
            children: (
              <Table
                size="small"
                pagination={false}
                columns={top_problems_columns}
                dataSource={top_problems_current_data}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => changeClusterProblemDetails(record),
                  };
                }}
              />
            ),
          },
          {
            key: '2',
            label: 'Системные',
            children: (
              <Table
                size="small"
                pagination={false}
                columns={top_problems_columns}
                dataSource={top_problems_systemic_data}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => changeClusterProblemDetails(record),
                  };
                }}
              />
            ),
          },
          {
            key: '3',
            label: 'Решенные',
            children: (
              <Table
                size="small"
                pagination={false}
                columns={top_problems_columns}
                dataSource={top_problems_current_data_final}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => changeClusterProblemDetails(record),
                  };
                }}
              />
            ),
          },
        ]}
      >

      </Collapse>

      </div>
  );
}

export default ProblemTableComponent;
